import { isNull, get } from "lodash"
import locales from "./../../../content.json"

export const checkIsValidResult = data => {
    return validateResultStep(get(data, ["result", "value"], "")) && !data.result.isValid
}

export const validateResultStep = value => {
    return !isNull(value)
}

const resultMale = {
    lose: {
        value: "Lose weight",
        title: locales[window.userLang].lose_weight,
        icon: "img/icon-loseweight.png"
    },
    muscle: {
        value: "Build Muscle",
        title: locales[window.userLang].build_muscle,
        icon: "img/icon-muscle.png"
    },
    tone: {
        value: "Body tone up",
        title: locales[window.userLang].tone_up,
        icon: "img/icon-tone.png"
    },
}

const resultFemale = {
    lose: {
        value: "Lose weight",
        title: locales[window.userLang].lose_weight,
        icon: "img/icon-loseweight.png"
    },
    tone: {
        value: "Body tone up",
        title: locales[window.userLang].tone_up,
        icon: "img/icon-tone.png"
    },
    love: {
        value: "Love myself",
        title: locales[window.userLang].love_myself,
        icon: "img/icon-love.png"
    },
    muscle: {
        value: "Gain Muscles",
        title: locales[window.userLang].gain_muscles,
        icon: "img/icon-muscle.png"
    },
}

export const resultData = {
    male: resultMale,
    female: resultFemale,
    other: resultFemale,
}